<div [formGroup]="fg()">
  <div class="action-setting">
    <div class="action-setting-title">
      {{ 'commonActions.environmentAudit.description' | labelsProvider }}
    </div>

    <mat-radio-group [value]="auditMode()" (change)="onRadioButtonChange($event.value)">
      <div class="radio-option">
        <mat-radio-button [value]="true">
          {{ 'commonActions.environmentAudit.enableLabel' | labelsProvider }}
        </mat-radio-button>
        <div class="radio-description">
          {{ 'commonActions.environmentAudit.enableDescription' | labelsProvider }}
        </div>
      </div>

      <div class="radio-option">
        <mat-radio-button [value]="false">
          {{ 'commonActions.environmentAudit.disableLabel' | labelsProvider }}
        </mat-radio-button>
        <div class="radio-description">
          {{ 'commonActions.environmentAudit.disableDescription' | labelsProvider }}
        </div>
      </div>
    </mat-radio-group>
  </div>
</div>
